import type { FieldSnapshot } from '@mio/shared';

type Acceptance = NonNullable<FieldSnapshot['controls']>['acceptances'][number];

/** A previous pass cannot authorize a candidate after a newer trusted result. */
export function isCurrentFieldAcceptance(snapshot: FieldSnapshot, acceptance: Acceptance) {
  const pr = snapshot.prs.find((candidate) => candidate.id === acceptance.prId);
  const latest = snapshot.runs
    .filter(
      (run) =>
        run.prId === acceptance.prId &&
        run.revision === acceptance.revision &&
        run.suite === 'acceptance' &&
        run.trusted &&
        (run.status === 'passed' || run.status === 'failed'),
    )
    .at(-1);
  return (
    pr?.revision === acceptance.revision &&
    latest?.id === acceptance.runId &&
    latest.status === 'passed'
  );
}
